// extracted by mini-css-extract-plugin
export default {"wrapper":"modal_wrapper__UR4hj","icon":"modal_icon__og+Zo"};